// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteFooter {
  background-color: #ffffff;
  padding: 60px 90px 50px;
}

.footerBrand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.footerLogo {
  height: 55px;
  width: auto;
}

.footerBrandTitle {
  font-weight: 700;
  font-size: 1.75rem;
  color: #222222;
  line-height: 1.1;
}

.footerBrandSubtitle {
  font-size: 0.85rem;
  color: #222222;
}

.footerContact {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footerContactItem {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #333333;
}

.footerContactIcon {
  color: #172639;
  font-size: 16px;
  margin-top: 4px;
}

.footerLinksHeading {
  color: #172639;
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 20px;
}

.footerLinksList {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footerLinksList a {
  color: #333333;
  text-decoration: none;
}

.footerLinksList a:hover {
  color: #eaa637;
}

@media (max-width: 768px) {
  .siteFooter {
    padding: 40px 24px 40px;
    text-align: left;
  }

  .footerLinksHeading {
    margin-top: 16px;
  }

  .footerLinksList {
    margin-bottom: 24px;
  }
}

@media (max-width: 575.98px) {
  .footerLinksList {
    margin-bottom: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".siteFooter {\n  background-color: #ffffff;\n  padding: 60px 90px 50px;\n}\n\n.footerBrand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.footerLogo {\n  height: 55px;\n  width: auto;\n}\n\n.footerBrandTitle {\n  font-weight: 700;\n  font-size: 1.75rem;\n  color: #222222;\n  line-height: 1.1;\n}\n\n.footerBrandSubtitle {\n  font-size: 0.85rem;\n  color: #222222;\n}\n\n.footerContact {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footerContactItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  color: #333333;\n}\n\n.footerContactIcon {\n  color: #172639;\n  font-size: 16px;\n  margin-top: 4px;\n}\n\n.footerLinksHeading {\n  color: #172639;\n  font-weight: 700;\n  font-size: 1.3rem;\n  margin-bottom: 20px;\n}\n\n.footerLinksList {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footerLinksList a {\n  color: #333333;\n  text-decoration: none;\n}\n\n.footerLinksList a:hover {\n  color: #eaa637;\n}\n\n@media (max-width: 768px) {\n  .siteFooter {\n    padding: 40px 24px 40px;\n    text-align: left;\n  }\n\n  .footerLinksHeading {\n    margin-top: 16px;\n  }\n\n  .footerLinksList {\n    margin-bottom: 24px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .footerLinksList {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
